import React from 'react';

export function Header({ transaction }) {
  const sender = transaction?.sender;

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <div className="company-identity">
          {sender?.logoImage && (
            <img
              src={sender.logoImage}
              alt={`${sender.companyName} logo`}
              className="company-logo"
            />
          )}
          <div className="company-info">
            {/* company-name is a label, not a page heading — use p to avoid h1 conflicts */}
            <p className="company-name">{sender?.companyName}</p>
            {(sender?.email || sender?.Website || sender?.whatsapp) && (
              <div className="company-contacts">
                {sender.email && (
                  <a
                    href={`mailto:${sender.email}`}
                    className="contact-chip contact-chip--email"
                    title={sender.email}
                  >
                    <i className="bi bi-envelope-fill" aria-hidden="true"></i>
                    <span>{sender.email}</span>
                  </a>
                )}
                {sender.Website && (
                  <a
                    href={`https://${sender.Website}`}
                    target="_blank"
                    rel="noreferrer"
                    className="contact-chip contact-chip--website"
                    title={sender.Website}
                  >
                    <i className="bi bi-globe2" aria-hidden="true"></i>
                    <span>{sender.Website}</span>
                  </a>
                )}
                {sender.whatsapp && (
                  <a
                    href={`https://api.whatsapp.com/send?phone=${sender.whatsapp}`}
                    target="_blank"
                    rel="noreferrer"
                    className="contact-chip contact-chip--whatsapp"
                    title={`WhatsApp: ${sender.whatsapp}`}
                  >
                    <i className="bi bi-whatsapp" aria-hidden="true"></i>
                    <span>{sender.whatsapp}</span>
                  </a>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="brand-badge">
          <img src="/images/swilshare-logo.png" alt="SwilShare" />
          <img src="/images/powerd-by.png" alt="Powered by SWIL" />
        </div>
      </div>
    </header>
  );
}
